import { z } from "zod";
export const taskDeletionReason = {
    MISRECOGNIZED: "misrecognized",
    WRONG_TEAM: "wrong_team",
    DUPLICATE: "duplicate",
    TECHNICAL_ERROR: "technical_error",
    OTHER: "other",
};
const taskDeletionReasonValues = Object.values(taskDeletionReason);
export const taskDeletionReasonSchema = z.enum(taskDeletionReasonValues);
// Shared between the delete-task request schema and this result schema to avoid drift
export function requireCommentWhenReasonIsOther(data, ctx) {
    if (data.reason === taskDeletionReason.OTHER && data.comment === undefined) {
        ctx.addIssue({ code: "custom", path: ["comment"], message: "comment is required when reason is 'other'" });
    }
}
export const taskDeletionResultSchema = z
    .object({
    reason: taskDeletionReasonSchema,
    comment: z.string().trim().min(1).optional(),
    deletedBy: z.uuid(),
})
    .superRefine(requireCommentWhenReasonIsOther);
